import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/documents/registries";
const truckingBidsResource = "api/truckingbids";
const resourceQuery = { orderBy: "id desc" };

export const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...resourceQuery });
    return request(`${resource}/getList${query}`, { method: "GET" }, { countInHeaders: true });
};

export const list = (params: OdataFilters) => request(`${resource}/getList${containsQuery(params)}`, { method: "GET" });

export const getItem = (id: number | string) => request(`${resource}/get/${id}`, { method: "GET" });

export const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

export const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export const createInvoice = (params: {}) => alertRequest(`${resource}/createInvoice`, body(params));

export const createAppendix = (params: {}) => alertRequest(`${resource}/createAppendix`, body(params));

export const createRegistryUsingBids = (params: {}) =>
    alertRequest(`${truckingBidsResource}/createRegistryUsingBids`, body(params));
